import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldX, Home, ArrowLeft } from 'lucide-react';

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Animated Icon */}
        <div className="relative mb-8">
          <div className="w-32 h-32 mx-auto bg-destructive rounded-full flex items-center justify-center shadow-2xl">
            <ShieldX className="w-16 h-16 text-destructive-foreground animate-pulse" />
          </div>
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-32 h-32 bg-destructive/20 rounded-full -z-10 animate-ping opacity-20"></div>
        </div>

        {/* Error Content */}
        <div className="space-y-6">
          <div>
            <h1 className="text-8xl font-bold text-destructive mb-4">
              403
            </h1>
            <h2 className="text-3xl font-bold text-foreground mb-2">
              Access denied
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              You don't have the necessary permissions to access this resource.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center justify-center space-x-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              <ArrowLeft size={20} />
              <span>Back</span>
            </button>

            <button
              onClick={() => navigate("/user/dashboard")}
              className="inline-flex items-center justify-center space-x-2 bg-card text-card-foreground px-6 py-3 rounded-lg font-medium border border-border hover:bg-muted transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              <Home size={20} />
              <span>Back to home</span>
            </button>
          </div>

          {/* Info Card */}
          <div className="mt-8 p-6 bg-card rounded-2xl shadow-lg border border-border">
            <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center justify-center space-x-2">
              <ShieldX className="w-5 h-5 text-destructive" />
              <span>Possible reasons</span>
            </h3>

            <div className="space-y-2 text-sm text-muted-foreground text-left">
              <p>• You are not logged in with the right account</p>
              <p>• You don't have the necessary access rights</p>
              <p>• This resource is reserved for administrators</p>
              <p>• Your session may have expired</p>
            </div>
          </div>

          {/* Support */}
          <div className="mt-8 p-4 bg-muted rounded-xl border border-border">
            <p className="text-sm text-muted-foreground mb-3">
              If you think this is an error, contact the administrator.
            </p>
            <button
              onClick={() => navigate("/user/contact-support")}
              className="text-primary hover:opacity-80 font-medium transition-colors"
            >
              Contact support
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 text-sm text-muted-foreground">
          <p>Error code: 403 | Unauthorized access</p>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
